export const theme = (dark) => ({
  bg: dark ? "#000000" : "#F5F5F7",
  card: dark ? "#1C1C1E" : "#FFFFFF",
  card2: dark ? "#2C2C2E" : "#F2F2F7",
  fg: dark ? "#F5F5F7" : "#1D1D1F",
  muted: dark ? "#98989D" : "#6E6E73",
  border: dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
  sidebar: dark ? "#0D0D0D" : "#FBFBFD",
  hover: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
  inputBg: dark ? "#1C1C1E" : "#F2F2F7",
  blue: "#0A84FF",
  green: "#30D158",
  orange: "#FF9F0A",
  red: "#FF375F",
  purple: "#BF5AF2",
  cyan: "#64D2FF",
  teal: "#6AC4DC",
  glow: dark
    ? "0 0 0 1px rgba(10,132,255,0.15), 0 8px 32px rgba(10,132,255,0.08)"
    : "0 0 0 1px rgba(10,132,255,0.12), 0 8px 32px rgba(10,132,255,0.06)",
  cardShadow: dark
    ? "0 1px 0 0 rgba(255,255,255,0.03)"
    : "0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04), 0 0 0 1px rgba(0,0,0,0.04)",
});
